module.exports = __webpack_public_path__ + "img/createresume.29898b22.svg";